import React, { useCallback } from "react";
import { ToolbarContainer } from "../components";
import { PageSizeDropdown } from "@td/ui";
import { useTasks } from "../contexts/tasks-context";
import CreateTask from "./CreateTask";

const pageSizeOptions = [
  { value: 50, label: 50 },
  { value: 75, label: 75 },
  { value: 100, label: 100 },
];

const ListViewToolbar = React.memo(() => {
  const { updateQueryParams, queryParams: { perPage }} = useTasks();

  const pageSizeValue = pageSizeOptions.find(({ value }) => value === perPage);
  const handlePageSizeChange = useCallback(({ value: perPage }) => {
    updateQueryParams({
      page: 1,
      perPage,
    });
  }, [updateQueryParams]);

  return (
    <ToolbarContainer>
      <CreateTask />

      <PageSizeDropdown
        value={pageSizeValue}
        onChange={handlePageSizeChange}
        options={pageSizeOptions}
        customStyles={{
          container: (provided) => ({
            ...provided,
            margin: "0 0 0 auto",
          }),
        }}
      />
    </ToolbarContainer>
  );
});

export default ListViewToolbar;
